<script setup lang="ts">
  import { ref } from 'vue';

  defineProps<{
    title: string;
    placeholder: string;
    maxLength?: number;
  }>();

  const emit = defineEmits<{
    (event: 'update:notes', value: string): void;
  }>();

  const notes = ref('');
  const currentLength = ref(0);

  function handleInput(event: Event) {
    const value = (event.target as HTMLTextAreaElement).value;
    notes.value = value;
    currentLength.value = value.length;
    emit('update:notes', value);
  }
</script>

<template>
  <div class="px-6 py-8">
    <h3 class="font-semibold text-left mb-2">
      {{ title }}
    </h3>
    <textarea
      id="observations"
      name="observations"
      class="w-full border border-border-color rounded-lg p-4 resize-none"
      :value="notes"
      :placeholder="placeholder"
      :maxlength="maxLength"
      @input="handleInput"
    />
    <p
      v-if="maxLength"
      class="text-xs text-gray-07"
    >
      {{ currentLength }}/{{ maxLength }} caracteres
    </p>
  </div>
</template>
